import { render, staticRenderFns } from "./districtsEditView.vue?vue&type=template&id=697d294d&scoped=true"
import script from "./districtsEditView.vue?vue&type=script&lang=js"
export * from "./districtsEditView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "697d294d",
  null
  
)

export default component.exports